export const getLanguageFromNavigatorHelper = (code: string) => {
    if (!code || code.indexOf('-') < 0) return code;

    const p = code.split('-');
    return p[0];
}